// VerifyEmail Component - Handle email verification from link
// © 2025 precatio, llc

import React, { useState, useEffect } from 'react';
import './AuthModal.css'; // Reuse auth modal styles

const VerifyEmail = ({ onComplete }) => {
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [error, setError] = useState('');

  useEffect(() => {
    verifyEmail();
  }, []);

  const verifyEmail = async () => {
    // Get token from URL
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (!token) {
      setStatus('error');
      setError('No verification token provided.');
      return;
    }

    try {
      const response = await fetch(`/api/auth/verify-email/${token}`);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Verification failed');
      }

      setStatus('success');
    } catch (err) {
      setStatus('error');
      setError(err.message);
    }
  };

  const handleGoHome = () => {
    // Clear URL params and go to home
    window.history.replaceState({}, document.title, '/');
    if (onComplete) {
      onComplete();
    }
  };

  return (
    <div className="auth-modal-overlay" style={{ position: 'fixed' }}>
      <div className="auth-modal">
        <div className="auth-modal-header">
          <img src="/iggy-icon.jpg" alt="Iggy" className="auth-modal-logo" />
          <h2>
            {status === 'verifying' && 'Verifying...'}
            {status === 'success' && 'Email Verified!'}
            {status === 'error' && 'Verification Failed'}
          </h2>
        </div>

        <div className="auth-form">
          {status === 'verifying' && (
            <p style={{ textAlign: 'center', color: '#a0a0a0' }}>
              Please wait while we verify your email...
            </p>
          )}

          {status === 'success' && (
            <>
              <div className="auth-success">
                Your email has been verified successfully! You now have full access to your account.
              </div>
              <button 
                onClick={handleGoHome}
                className="auth-submit"
              >
                Start Using Precat.io
              </button>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="auth-error">
                {error || 'Something went wrong. Please try again or contact support.'}
              </div>
              <button 
                onClick={handleGoHome}
                className="auth-submit"
              >
                Go to Home
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
